import React from "react"

import Layout from "../components/common/layout/layout"
import SEO from "../components/common/layout/seo"
import Navigation from "../components/common/navigation/navigation"

import Header from "../components/sections/header"
import Features from "../components/sections/features"
import Footer from "../components/sections/footer"
import GetStarted from "../components/sections/getstarted"

import SubHeading from "../components/sections/subheading"
//import Pricing from "../components/sections/pricing"

//import Junk from "../components/common/auth/loginbutton"


const IndexPage = () => (
  <Layout>
    <SEO title="GPTakein" />
    <Navigation />
    <Header />
    <SubHeading />
    <Features />
    <GetStarted />
    <Footer />
  </Layout>
)

export default IndexPage
